<template>
  <v-card class="d-flex flex-column align-center c-dados-nf-card">
    <v-card-title>
      <v-row class="mt-3 justify-center align-center">
        <v-col class="d-flex flex-row align-center justify-end mb-0 pb-0" cols="12" sm="3" md="12">
          <v-switch v-model="dadosNotaLocal.edicao" label="Existem pendencias?" />
          <v-btn elevation="9" class="mx-2" fab dark small color="#363494">
            <v-icon dark @click="atualizarObservacaoNota">save</v-icon>
          </v-btn>
        </v-col>

        <v-col class="flex-grow-0 mb-0 pb-0" cols="3" sm="3" md="3">
          <v-text-field
            outlined
            class="ml-3"
            filled
            readonly
            label="VALOR DO DOCUMENTO"
            :value="dadosNotaLocal.valorNf | dinheiro"
          />
        </v-col>

        <v-col class="flex-grow-0 mb-0 pb-0" cols="12" lg="8" md="8" sm="6">
          <v-text-field
            outlined
            class="ml-3"
            label="NOTA/RECIBO"
            v-model="dadosNotaLocal.notaRecibo"
          />
        </v-col>

        <v-col class="flex-grow-0 mb-0 pb-0" cols="2" lg="2" sm="2" md="2">
          <v-text-field
            outlined
            readonly
            class="ml-3"
            label="DATA NOTA/RECIBO"
            :value="formatarDataExibicao(dadosNotaLocal.dataRecibo)"
          />
        </v-col>

        <v-col class="flex-grow-0 mb-0 pb-0" cols="3" lg="3" sm="3" md="3">
          <v-menu
            ref="menu"
            v-model="menuDataRecibo"
            :close-on-content-click="false"
            transition="scale-transition"
            origin="center center"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                :value="formatarDataExibicao(dateReciboPiker.dataNova)"
                label="EDITAR DATA DO DOCUMENTO"
                hint="Edite a data do documento"
                persistent-hint
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dateReciboPiker.dataNova"
              :active-picker.sync="activePickerDataRecibo"
              min="1950-01-01"
              @change="dateSave"
            />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <VueEditor placeholder="Edite as observacoes do documento" v-model="dadosNotaLocal.observacoes" />
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <gerenciadorAnexos
            tipo-entidade="nota"
            modo="persistido"
            :entidade-id="dadosNotaLocal.id"
            :aberto-inicial="true"
            mensagem-opcional="Os anexos sao opcionais e ficam vinculados a esta nota."
            @arquivo-excluido="atualizarListasAposAnexo"
            @upload-completo="atualizarListasAposAnexo"
          />
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-title class="c-dados-nf-card__toolbar">
      <v-text-field
        class="ma-0 pa-0"
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar Dados"
        single-line
        hide-details
      />
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="itensNota"
      :search="search"
      :loading="loadingItens"
      loading-text="Carregando itens da nota"
      no-data-text="Nenhum item encontrado para esta nota."
      class="mt-0 pt-0 c-table-lista__dados__notas c-table-lista__dados__notas--detalhes"
      disable-pagination
      hide-default-footer
    >
      <template #item.itemPregao="{ item }">
        <div class="d-flex align-center py-2 c-coluna-item-pregao">
          <img
            :src="item.imageUrl"
            alt="Imagem"
            width="56"
            height="56"
            class="rounded mr-3"
            style="object-fit: cover;"
          />
          <div class="c-table__meta-wrap">
            <div class="c-table__meta c-table__meta--principal">
              {{ item.idGenericaProduto || "-" }} - {{ item.descricao_edital || "Sem descricao do item" }}
            </div>
            <div class="c-table__meta">
              {{ item.name || "-" }} | {{ obterRotuloUnidade(item.tipoUnidade) }}
            </div>
          </div>
        </div>
      </template>

      <template #item.valorProdutoPregao="{ item }">
        <div class="c-cell-readonly c-cell-readonly--numeric c-coluna-valor">
          {{ item.valorProdutoPregao | dinheiro }}
        </div>
      </template>

      <template #item.registroEmissaoNf="{ item }">
        <div class="c-cell-readonly c-cell-readonly--numeric c-coluna-quantidade">
          {{ formatarQuantidade(item.registroEmissaoNf) }}
        </div>
      </template>

      <template #item.valorItemNotaEmitida="{ item }">
        <div class="c-cell-readonly c-cell-readonly--numeric c-coluna-total">
          {{ item.valorItemNotaEmitida | dinheiro }}
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from "axios";
import barramento from "@/barramento";
import { urlApi, showError } from "@/global";
import {
  formatarDataParaExibicao as formatarDataExibicaoBr,
  normalizarDataEntrada as normalizarDataIso,
} from "@/utils/date";
import { obterRotuloTipoUnidade } from "@/utils/tiposUnidade";
import { VueEditor } from "vue2-editor";
import gerenciadorAnexos from "../anexos/gerenciadorAnexos";

export default {
  name: "dadosNF",
  props: {
    dadosProdutosNF: { type: Object, default: () => ({}) },
    itemFiltradoNota: { type: Array, default: () => [] },
    listaDataReciboNota: String,
    empenhoId: [Number, String],
    pregaoId: [Number, String],
    clouseTelaDadosNota: [Function, Boolean],
  },
  components: { VueEditor, gerenciadorAnexos },

  data() {
    return {
      search: "",
      headers: [
        { text: "Item do Pregao", value: "itemPregao", sortable: false, width: "58%", align: "start", cellClass: "c-coluna-item-pregao", class: "c-coluna-item-pregao" },
        { text: "Valor", value: "valorProdutoPregao", sortable: false, width: "14%", align: "end", cellClass: "c-coluna-valor", class: "c-coluna-valor" },
        { text: "Quantidade", value: "registroEmissaoNf", sortable: false, width: "12%", align: "end", cellClass: "c-coluna-quantidade", class: "c-coluna-quantidade" },
        { text: "Total", value: "valorItemNotaEmitida", sortable: false, width: "16%", align: "end", cellClass: "c-coluna-total", class: "c-coluna-total" },
      ],
      itensNota: [],
      loadingItens: false,
      dadosObs: {},
      dateReciboPiker: {
        dataNova: "",
      },
      menuDataRecibo: false,
      activePickerDataRecibo: null,
      dadosNotaLocal: {
        id: null,
        edicao: false,
        valorNf: 0,
        notaRecibo: "",
        dataRecibo: "",
        observacoes: "",
      },
    };
  },

  watch: {
    menuDataRecibo(val) {
      val && setTimeout(() => (this.activePickerDataRecibo = "Ano"));
    },
    clouseTelaDadosNota() {
      this.dateReciboPiker.dataNova = "";
    },
    dadosProdutosNF: {
      immediate: true,
      handler(nota) {
        this.sincronizarDadosNota(nota);
      },
    },
  },

  methods: {
    formatarDataExibicao(valor) {
      return formatarDataExibicaoBr(valor);
    },

    normalizarData(valor) {
      return normalizarDataIso(valor);
    },

    sincronizarDadosNota(nota) {
      const notaNormalizada = nota || {};
      const dataReciboNormalizada = this.normalizarData(notaNormalizada.dataRecibo);

      this.dadosNotaLocal = {
        id: notaNormalizada.id || null,
        edicao: !!notaNormalizada.edicao,
        valorNf: Number(notaNormalizada.valorNf) || 0,
        notaRecibo: notaNormalizada.notaRecibo || "",
        dataRecibo: dataReciboNormalizada,
        observacoes: this.normalizarObservacoes(notaNormalizada.observacoes),
      };
      this.dateReciboPiker.dataNova = "";

      if (notaNormalizada.id) {
        this.carregarItensNota(notaNormalizada.id);
      } else {
        this.itensNota = [];
      }
    },

    normalizarObservacoes(observacoes) {
      if (typeof observacoes === "string") return observacoes;
      return "";
    },

    async carregarItensNota(notaId) {
      this.loadingItens = true;

      try {
        const res = await axios.get(`${urlApi}/nota/${notaId}/itens`);
        this.itensNota = (res.data || []).map((item) => ({
          ...item,
          valorProdutoPregao: Number(item.valorProdutoPregao) || 0,
          registroEmissaoNf: Number(item.registroEmissaoNf) || 0,
          valorItemNotaEmitida: Number(item.valorItemNotaEmitida) || 0,
        }));
      } catch (err) {
        showError(err);
        this.itensNota = [];
      } finally {
        this.loadingItens = false;
      }
    },

    dateSave(date) {
      const dataNormalizada = this.normalizarData(date);
      this.$refs.menu.save(dataNormalizada);
      this.dadosNotaLocal.dataRecibo = dataNormalizada;
      this.dateReciboPiker.dataNova = dataNormalizada;
    },

    formatarQuantidade(valor) {
      const numero = Number(valor) || 0;

      return numero.toLocaleString("pt-BR", {
        minimumFractionDigits: Number.isInteger(numero) ? 0 : 2,
        maximumFractionDigits: 4,
      });
    },

    obterRotuloUnidade(tipoUnidade) {
      return obterRotuloTipoUnidade(tipoUnidade);
    },

    atualizarListasAposAnexo() {
      if (this.empenhoId) {
        barramento.EnviarNotas(true, this.empenhoId);
      }
      if (this.pregaoId) {
        barramento.EnviarLoadEmpenho(true, this.pregaoId);
      }
      barramento.EnviarLoadPregao(true);
    },

    atualizarObservacaoNota() {
      this.dadosObs.observacoes = this.dadosNotaLocal.observacoes;
      this.dadosObs.edicao = this.dadosNotaLocal.edicao;
      this.dadosObs.notaRecibo = this.dadosNotaLocal.notaRecibo;
      this.dadosObs.dataRecibo = this.normalizarData(this.dadosNotaLocal.dataRecibo);

      axios
        .put(`${urlApi}/atualizarNota/${this.dadosNotaLocal.id}`, this.dadosObs)
        .then(() => {
          this.dateReciboPiker.dataNova = "";
          if (this.empenhoId) {
            barramento.EnviarNotas(true, this.empenhoId);
          }
          if (this.pregaoId) {
            barramento.EnviarLoadEmpenho(true, this.pregaoId);
          }
          barramento.EnviarLoadPregao(true);
          this.$toasted.global.defaultSuccess();
        })
        .catch(showError);
    },
  },
};
</script>

<style>
.c-dados-nf-card {
  width: 100%;
  padding: 0 0 28px;
  box-sizing: border-box;
}

.c-dados-nf-card__toolbar {
  width: 100%;
  justify-content: center;
  padding-bottom: 12px;
}

.c-table-lista__dados__notas table {
  width: 100%;
  margin-top: 5px;
  table-layout: fixed;
}

.c-table-lista__dados__notas tr {
  outline: solid 4px #ffffff !important;
  background: #f5f5f5;
}

.c-table-lista__dados__notas td {
  padding: 18px 12px !important;
  vertical-align: middle;
}

.c-table-lista__dados__notas .v-data-table__wrapper {
  width: 100%;
  border-radius: 7px;
  overflow-x: hidden;
}

.c-table-lista__dados__notas--detalhes {
  width: calc(100% - 48px);
  margin: 0 24px 24px;
  align-self: stretch;
}

.c-table-lista__dados__notas thead th {
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  color: #5c5c5c !important;
  white-space: nowrap;
}

.c-table-lista__dados__notas thead th,
.c-table-lista__dados__notas tbody td {
  box-sizing: border-box;
}

.c-table-lista__dados__notas tbody td:first-child {
  padding-right: 24px !important;
}

.c-table__meta-wrap {
  min-width: 0;
}

.c-table__meta {
  margin-bottom: 0;
  font-size: 0.95rem;
  line-height: 1.35;
  color: #555;
}

.c-table__meta--principal {
  font-weight: 500;
  color: #333;
}

.c-cell-readonly {
  width: 100%;
  display: flex;
  align-items: center;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.35;
}

.c-cell-readonly--numeric {
  justify-content: flex-end;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.c-coluna-item-pregao {
  width: 58%;
}

.c-coluna-valor {
  width: 14%;
}

.c-coluna-quantidade {
  width: 12%;
}

.c-coluna-total {
  width: 16%;
}
</style>
